var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NxSelect',{attrs:{"value":_vm.localValue,"options":_vm.listOptions,"labelText":_vm.label || '',"id":"selectTag","placeholder":_vm.placeholder,"multiple":_vm.multiple !== undefined ? _vm.multiple : false},on:{"update:value":_vm.handleValueUpdate}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b1531c6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nexum/components/custom-selects/NxSelectTag.vue
// module id = null
// module chunks = 